import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import SocialProofSection from "@/components/SocialProofSection";
import GuaranteeSection from "@/components/GuaranteeSection";
import FounderSection from "@/components/FounderSection";
import BlogSection from "@/components/BlogSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://negocioconectado.com/#localbusiness",
  name: "Negócio Conectado",
  description:
    "Consultoria empresarial com atendimento em todo o Brasil. Vendas B2B, gestão financeira, telemedicina corporativa, redução de taxas de cartão, planejamento tributário, proteção de marca e certificado digital.",
  url: "https://negocioconectado.com",
  telephone: "+5582999763522",
  image: "https://negocioconectado.com/og-image.png",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Av. Vieira de Brito, 399E – Centro",
    addressLocality: "Palmeira dos Índios",
    addressRegion: "AL",
    postalCode: "57600-000",
    addressCountry: "BR",
  },
  areaServed: { "@type": "Country", name: "Brasil" },
  sameAs: ["https://www.instagram.com/negocioconectado/"],
  priceRange: "$$",
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "18:00",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://negocioconectado.com/#organization",
  name: "Negócio Conectado",
  url: "https://negocioconectado.com",
  logo: "https://negocioconectado.com/og-image.png",
  description:
    "Consultoria empresarial para PMEs de todo o Brasil. Vendas B2B, gestão financeira, telemedicina, redução de taxas, planejamento tributário e proteção de marca.",
  foundingDate: "2004",
  founder: { "@type": "Person", name: "Jorge Regis" },
  sameAs: ["https://www.instagram.com/negocioconectado/"],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+5582999763522",
    contactType: "customer service",
    availableLanguage: "Portuguese",
    areaServed: "BR",
  },
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: "https://negocioconectado.com",
  name: "Negócio Conectado",
  inLanguage: "pt-BR",
  publisher: { "@id": "https://negocioconectado.com/#organization" },
};

const homeFaqs = [
  {
    q: "Quais serviços a Negócio Conectado oferece?",
    a: "Oferecemos consultoria empresarial completa para PMEs: estruturação de vendas B2B, gestão financeira (BPO), planejamento tributário, telemedicina corporativa, redução de taxas de cartão, proteção de marca no INPI, sede virtual e emissão de certificado digital (e-CNPJ, e-CPF, A1 e A3).",
  },
  {
    q: "A Negócio Conectado atende empresas em todo o Brasil?",
    a: "Sim. Atendemos empresas em todas as regiões do Brasil de forma remota, com sede física em Palmeira dos Índios, Alagoas. As reuniões são feitas por videoconferência e WhatsApp.",
  },
  {
    q: "Vocês atendem MEI e pequenas empresas?",
    a: "Sim. Nosso foco é justamente MEIs, microempresas e empresas de pequeno e médio porte que querem profissionalizar a gestão, vender mais e pagar menos imposto de forma legal.",
  },
  {
    q: "Existe garantia nos serviços?",
    a: "Sim. Todos os nossos serviços contam com garantia de 100% de satisfação ou seu dinheiro de volta.",
  },
  {
    q: "Como faço para contratar um serviço?",
    a: "Basta clicar no botão de WhatsApp do site (+55 82 99976-3522). Em horário comercial (segunda a sexta, 8h às 18h) o atendimento é imediato e sem compromisso.",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: homeFaqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const Index = () => (
  <>
    <SEO
      canonical="/"
      description="Consultoria empresarial para PMEs em todo o Brasil: vendas B2B, gestão financeira, telemedicina, redução de taxas e proteção de marca."
      keywords="consultoria empresarial, consultoria empresarial Brasil, vendas B2B, gestão financeira, telemedicina corporativa, redução taxas cartão, planejamento tributário, proteção de marca INPI, BPO financeiro, sede virtual, mentoria empresarial, consultoria para PME"
      jsonLd={[localBusinessSchema, organizationSchema, websiteSchema, faqSchema]}
    />
    <Header />
    <main>
      <HeroSection />
      <ServicesSection />
      <SocialProofSection />
      <GuaranteeSection />
      <FounderSection />
      <BlogSection />
      <FAQSection faqs={homeFaqs} />
    </main>
    <Footer />
    <WhatsAppButton />
  </>
);

export default Index;
